/* RP BEAUTY — Wishlist / Guardados (localStorage, sin app). Quick win Fase 3 shop.app.
   Corazon en tarjetas de grid + ficha de producto; pagina /pages/guardados; contador en menu. */
(function () {
  var KEY = "rp_wishlist";
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } }
  function saveArr(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return get().indexOf(h) > -1; }
  function count() { return get().length; }
  function toggle(h) {
    var a = get(), i = a.indexOf(h), added = i < 0;
    if (added) a.unshift(h); else a.splice(i, 1);
    saveArr(a); updateCount();
    document.dispatchEvent(new CustomEvent("rp:wishlist", { detail: { handle: h, saved: added } }));
    return added;
  }
  window.RPWishlist = { get: get, has: has, toggle: toggle, count: count };

  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
    '<path d="M12 21s-7.6-4.7-10.1-9.3C.2 8.4 1.9 4.7 5.5 4.7c2 0 3.4 1.1 4.2 2.4C10.5 5.8 11.9 4.7 13.9 4.7c3.6 0 5.3 3.7 3.6 7C15 16.3 12 21 12 21z"/></svg>';

  function handleFrom(href) { if (!href) return null; var m = href.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  function cardBtn(active) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "rpwish-btn" + (active ? " is-active" : "");
    b.setAttribute("aria-label", "Guardar en favoritos"); b.setAttribute("aria-pressed", active);
    b.innerHTML = HEART; return b;
  }

  function decorateCards() {
    var links = document.querySelectorAll(".product-card a[href*='/products/']");
    var seen = [];
    links.forEach(function (link) {
      var card = link.closest(".product-card");
      if (!card || seen.indexOf(card) > -1) return; seen.push(card);
      if (card.querySelector(".rpwish-btn")) return;
      var h = handleFrom(link.getAttribute("href")); if (!h) return;
      card.classList.add("rpwish-host");
      var b = cardBtn(has(h));
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = toggle(h); b.classList.toggle("is-active", s); b.setAttribute("aria-pressed", s);
      });
      card.appendChild(b);
    });
  }

  function decorateProductPage() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector(".rpwish-pdp")) return;
    var h = handleFrom(location.pathname); if (!h) return;
    var anchor = document.querySelector(".rppay-buynow") || document.querySelector("product-form-component button[name='add']") || document.querySelector("button[name='add']");
    if (!anchor) return;
    var b = document.createElement("button");
    b.type = "button"; b.className = "rpwish-pdp" + (has(h) ? " is-active" : ""); b.setAttribute("aria-pressed", has(h));
    b.innerHTML = HEART + "<span>" + (has(h) ? "Guardado" : "Guardar en favoritos") + "</span>";
    b.addEventListener("click", function () {
      var s = toggle(h); b.classList.toggle("is-active", s); b.setAttribute("aria-pressed", s);
      b.querySelector("span").textContent = s ? "Guardado" : "Guardar en favoritos";
    });
    var host = anchor.closest(".product-details") ? anchor.parentNode : anchor.parentNode;
    host.insertBefore(b, anchor.nextSibling);
  }

  function updateCount() {
    var n = count();
    document.querySelectorAll("[data-rpwish-count]").forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? "" : "none";
    });
    // Badge en el enlace "Guardados" del menu
    document.querySelectorAll("a[href*='/pages/guardados']").forEach(function (a) {
      var badge = a.querySelector(".rpwish-badge");
      if (n > 0) {
        if (!badge) { badge = document.createElement("span"); badge.className = "rpwish-badge"; a.appendChild(badge); }
        badge.textContent = n;
      } else if (badge) { badge.remove(); }
    });
  }

  function renderPage() {
    var grid = document.getElementById("rpwish-grid"); if (!grid) return;
    var map = window.rpAllProducts || {}, items = get(), html = "", n = 0;
    var esc = function (s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; };
    items.forEach(function (h) {
      var p = map[h]; if (!p) return; n++;
      var cmp = p.c ? '<span class="rpwish-cmp">' + esc(p.c) + "</span>" : "";
      var img = p.i ? '<img src="' + p.i + '" alt="' + esc(p.t) + '" loading="lazy">' : "";
      html += '<div class="rpwish-card" data-h="' + esc(h) + '">' +
        '<a href="' + p.u + '"><div class="rpwish-imgwrap">' + img + "</div>" +
        '<div class="rpwish-name">' + esc(p.t) + "</div>" +
        '<div class="rpwish-price">' + esc(p.p) + cmp + "</div></a>" +
        '<button class="rpwish-remove" type="button" data-h="' + esc(h) + '" aria-label="Quitar de guardados">Quitar</button></div>';
    });
    var empty = document.getElementById("rpwish-empty");
    if (n > 0) {
      grid.innerHTML = html; grid.style.display = "";
      if (empty) empty.style.display = "none";
      grid.querySelectorAll(".rpwish-remove").forEach(function (btn) {
        btn.addEventListener("click", function () { toggle(btn.getAttribute("data-h")); renderPage(); });
      });
    } else { grid.style.display = "none"; if (empty) empty.style.display = ""; }
  }
  window.RPWishlist.renderPage = renderPage;

  // Corre el decorado de tarjetas (UI secundaria) FUERA del hilo critico -> no empeora INP en la carga.
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(fn, { timeout: 1500 }); }
  function init() { decorateProductPage(); updateCount(); renderPage(); idle(decorateCards); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  // Re-escaneo para tarjetas cargadas async (recomendados), tambien en idle.
  idle(function () { decorateCards(); updateCount(); });
})();
